<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.edit.entities.other.addressSearch' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" *ngIf="type" style="padding: 10px">
    <div style="display: flex; flex-direction: row;">
        <h5 class="roboSubTitle">{{'invoices.edit.entities.other.type' | translate}}:</h5>
        <h5 style="flex: 1; margin-left: 5px;" class="roboSubTitle">{{type.description}}</h5>
    </div>
    <div style="display: flex; flex-direction: row;align-items: baseline;flex-wrap: wrap;">
        <h5 class="roboSubTitle">{{'invoices.edit.entities.other.searchBy' | translate}}:</h5>
        <div class="form-check" style="margin-left: 10px;">
            <input class="form-check-input" type="radio" name="group1" id="flexRadioDefault1" [checked]="searchFilter == 'partita_iva'" (change)="searchFilter = 'partita_iva'">
            <label class="form-check-label" for="flexRadioDefault1">{{ 'invoices.edit.entities.other.piva' | translate }}</label>
        </div>
        <div class="form-check" style="margin-left: 10px;">
            <input class="form-check-input" type="radio" name="group1" id="flexRadioDefault2" [checked]="searchFilter == 'denominazione'" (change)="searchFilter = 'denominazione'">
            <label class="form-check-label" for="flexRadioDefault2">{{ 'invoices.edit.entities.other.denomination' | translate }}</label>
        </div>
        <div *ngIf="innerWidth! <= 767" class="break" style="margin-bottom: 10px;"></div>
        <div class="input-group" style="margin-left: 10px; flex: 1;">
            <input type="text" [ngClass]="( titleSearch.length > 3 ) ? '' : 'borderRed'" [ngStyle]="{'border-radius': '10px 0px 0px 10px'}" [(ngModel)]="titleSearch" (keyup)="search($event)" class="form-control" [placeholder]="'placeholder.searchByName' | translate" aria-label="Cerca per nome" aria-describedby="basic-addon1">
            <span class="input-group-text" id="basic-addon1" (click)="search(null)"><i class="bi bi-search"></i> <!--{{ 'general.search' | translate }}--> </span>
        </div>
    </div>
    <div style="align-items: baseline;flex-wrap: wrap;" class="text-right mt-2">
        <button [disabled]="previousPage==currentPage" class="btn btn-sm mr-1" (click)="prev()">
            <i class="bi bi-caret-left-fill"></i>
        </button>
        <button [disabled]="currentPage==nextPage" class="btn btn-sm" (click)="next()">
            <i class="bi bi-caret-right-fill"></i>
        </button>
    </div>
    <div style="margin: 0;margin-top: 5px;overflow-x: auto;">
        <table class="table" *ngIf="listAddress && listAddress.length > 0">
            <thead>
                <tr>
                    <th scope="col" style="max-width: 40px; width: 40px;"></th>
                    <th scope="col">{{'invoices.edit.entities.other.denomination' | translate}}</th>
                    <th scope="col">{{'invoices.edit.entities.other.piva' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let doc of listAddress" (click)="doc.selected = true; selectOne(doc)" style="cursor: pointer;">
                    <td>
                        <input type="checkbox" class="form-check-input" style="margin-left: 0;" [(ngModel)]="doc.selected" (ngModelChange)="selectOne(doc)">
                    </td>
                    <td>
                        <h5>{{doc.denominazione}}</h5>
                    </td>
                    <td>
                        <h5>{{doc.partita_iva}}</h5>
                    </td>
                </tr>
            </tbody>    
        </table>
        <ng-container *ngIf="listAddress && listAddress.length == 0 && !first && !loading">
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
        </ng-container>
        <app-loading *ngIf="loading"></app-loading>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()">{{ 'general.save' | translate }}</button>
</div>